export const languageData = [
  { defaultValue: "afrikaans", lang: "Afrikaans", checked: false },
  { defaultValue: "albanian", lang: "Albanian", checked: false },
  { defaultValue: "arabic", lang: "Arabic", checked: false },
  { defaultValue: "armenian", lang: "Armenian", checked: false },
  { defaultValue: "asl", lang: "ASL American Sign Language", checked: false },
  { defaultValue: "bengali", lang: "Bengali", checked: false },
  { defaultValue: "bosnian", lang: "Bosnian", checked: false },
  { defaultValue: "bulgarian", lang: "Bulgarian", checked: false },
  { defaultValue: "chinese", lang: "Chinese", checked: false },
  { defaultValue: "croatian", lang: "Croatian", checked: false },
  { defaultValue: "czech", lang: "Czech/Slovak", checked: false },
  { defaultValue: "Danish", lang: "Danish", checked: false },
  { defaultValue: "dutch", lang: "Dutch", checked: false },
  { defaultValue: "Estonian", lang: "Estonian", checked: false },
  { defaultValue: "farsi", lang: "Farsi", checked: false },
  { defaultValue: "filipino", lang: "Filipino", checked: false },
  { defaultValue: "finnish", lang: "Finnish", checked: false },
  { defaultValue: "french", lang: "French", checked: false },
  { defaultValue: "gaelic", lang: "Gaelic", checked: false },
  { defaultValue: "georgian", lang: "Georgian", checked: false },
  { defaultValue: "german", lang: "German", checked: false },
  { defaultValue: "greek", lang: "Greek", checked: false },
  { defaultValue: "hawaiian", lang: "Hawaiian", checked: false },
  { defaultValue: "hebrew", lang: "Hebrew", checked: false },
  { defaultValue: "hindi", lang: "Hindi", checked: false },
  { defaultValue: "hungarian", lang: "Hungarian", checked: false },
  { defaultValue: "indonesian", lang: "Indonesian", checked: false },
  { defaultValue: "italian", lang: "Italian", checked: false },
  { defaultValue: "japanese", lang: "Japanese", checked: false },
  { defaultValue: "korean", lang: "Korean", checked: false },
  { defaultValue: "lao", lang: "Lao", checked: false },
  { defaultValue: "latvian", lang: "Latvian", checked: false },
  { defaultValue: "lithuanian", lang: "Lithuanian", checked: false },
  { defaultValue: "malay", lang: "Malay", checked: false },
  { defaultValue: "mandarin", lang: "Mandarin", checked: false },
  { defaultValue: "nepali", lang: "Nepali", checked: false },
  { defaultValue: "norwegian", lang: "Norwegian", checked: false },
  { defaultValue: "polish", lang: "Polish", checked: false },
  { defaultValue: "portuguese", lang: "Portuguese", checked: false },
  { defaultValue: "punjabi", lang: "Punjabi", checked: false },
  { defaultValue: "romanian", lang: "Romanian", checked: false },
  { defaultValue: "russian", lang: "Russian", checked: false },
  { defaultValue: "serbian", lang: "Serbian", checked: false },
  { defaultValue: "sindhi", lang: "Sindhi", checked: false },
  { defaultValue: "singhalese", lang: "Singhalese", checked: false },
  { defaultValue: "slovenian", lang: "Slovenian", checked: false },
  { defaultValue: "spanish", lang: "Spanish", checked: false },
  { defaultValue: "swahili", lang: "Swahili", checked: false },
  { defaultValue: "swedish", lang: "Swedish", checked: false },
  { defaultValue: "tagalog", lang: "Tagalog", checked: false },
  { defaultValue: "taiwanese", lang: "Taiwanese", checked: false },
  { defaultValue: "thai", lang: "Thai", checked: false },
  { defaultValue: "turkish", lang: "Turkish", checked: false },
  { defaultValue: "ukrainian", lang: "Ukrainian", checked: false },
  { defaultValue: "urdu", lang: "Urdu", checked: false },
  { defaultValue: "vietnamese", lang: "Vietnamese", checked: false },
  { defaultValue: "yugoslavian", lang: "Yugoslavian", checked: false },
];
